import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  fetchChannelsSuccess,
  fetchChannelsFailure,
  saveChannelSuccess,
  saveChannelFailure,
  deleteChannelSuccess,
  deleteChannelFailure,
  updateChannelSuccess,
  updateChannelFailure,
  fetchChannelByIdSuccess,
  fetchChannelByIdFailure,
} from "./action.js";

import {
  fetchChannels,
  saveChannel,
  deleteChannel,
  updateChannel,
  fetchChannelById,
} from "./channel.js";

// 🔹 Fetch Channels
function* fetchChannelsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const callback = action.payload?.callback || action.callback;


    const data = yield call(fetchChannels, apiPayloadRequest || {});

    yield put(fetchChannelsSuccess(data?.data || []));

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: data?.data,
        totalRecords: data?.totalRecords,
      });
    }
  } catch (error) {
    yield put(fetchChannelsFailure(error.message));
    const callback = action.payload?.callback || action.callback;
    if (typeof callback === "function") {
      callback({ type: 0, error: error.message });
    }
  }
}

// 🔹 Save Channel
function* saveChannelSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const data = yield call(saveChannel, apiPayloadRequest);

    yield put(saveChannelSuccess(data?.data || []));

    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: data?.data });
    }
  } catch (error) {
    yield put(saveChannelFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

// 🔹 Delete Channel
function* deleteChannelSaga(action) {
  try {
    const { _id, callback } = action.payload;
    const data = yield call(deleteChannel, _id);

    if (data?.type === 1) {
      yield put(deleteChannelSuccess({ _id }));
      if (callback) callback(data);
    } else {
      yield put(deleteChannelFailure(data?.error || "Delete failed"));
      if (callback) callback(data);
    }
  } catch (error) {
    yield put(deleteChannelFailure(error.message));
    if (action.payload.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}

// 🔹 Update Channel
function* updateChannelSaga(action) {
  try {
    const { payload, callback } = action;
    const data = yield call(updateChannel, payload);

    yield put(updateChannelSuccess(data?.data || payload));
    if (callback) callback({ type: 1, data: data?.data });
  } catch (error) {
    yield put(updateChannelFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }

}

// 🔹 Fetch Channel by ID
function* fetchChannelByIdSaga(action) {
  try {
    const { _id, callback } = action.payload;
    const data = yield call(fetchChannelById, _id);
    const channel = Array.isArray(data?.data) ? data.data[0] : null;

    if (channel) {
      yield put(fetchChannelByIdSuccess(channel));
      if (callback) callback({ type: 1, data: channel });
    } else {
      throw new Error("Channel not found");
    }
  } catch (error) {
    yield put(fetchChannelByIdFailure(error.message));
    if (action.payload.callback)
      action.payload.callback({ type: 0, error: error.message });
  }
}

// 🔹 Watcher
export default function* channelsWatcherSaga() {
  yield takeLatest(actionTypes.FETCH_CHANNELS_REQUEST, fetchChannelsSaga);
  yield takeLatest(actionTypes.SAVE_CHANNEL_REQUEST, saveChannelSaga);
  yield takeLatest(actionTypes.DELETE_CHANNEL_REQUEST, deleteChannelSaga);
  yield takeLatest(actionTypes.UPDATE_CHANNEL_REQUEST, updateChannelSaga);
  yield takeLatest(actionTypes.FETCH_CHANNEL_BY_ID_REQUEST, fetchChannelByIdSaga);
}
